import React from "react";

//Component===============================
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";

import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";

import FormLabel from "@material-ui/core/FormLabel";
import TextField from '@material-ui/core/TextField';
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";

//ICON ===============================
import SendIcon from "@material-ui/icons/Send";
import PriorityHighIcon from "@material-ui/icons/PriorityHigh";

import classNames from 'classnames';
import ConfigHost from "ConfigHost"
import {thaiBath} from "ConvertFormat"
import { APIGet,APIPost } from "APIRequest"
import URL from "UrlServer"
import * as Alert from "alertService"

//Style===============================
import withStyles from "@material-ui/core/styles/withStyles";
// import loginPageStyle from "assets/jss/material-dashboard-pro-react/views/loginPageStyle.jsx";
import regularFormsStyle from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";

const styles = {
    ...regularFormsStyle,
    container2: {
        paddingLeft: 16,
        paddingRight: 16,
        display: 'flex',
        flexWrap: 'wrap',
    },
    container: {
      display: 'flex',
      flexWrap: 'wrap',
    },
    dense: {
      marginTop: 16,
    },
    mt16: {
      marginTop: 16,
    },
    mt20: {
      marginTop: 20,
    },
    menu: {
      width: 200,
    },
    marginRight: {
        float: "right !important"
    },
}
class ForTestPage extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            statusPlaying:false
        }
      }
    componentDidMount(){
        this.onPlaying()
    }
   
    // handleChangeNameVal = event => {
    //     // console.log(">>>>> " + event.target.name , event.target.value );
    //     this.setState({ 
    //         [event.target.name]: event.target.value ,
    //     },()=>{
    //     });

    // };
    onPlaying = () => {
        if(this.state.statusPlaying){
            this.setState({statusPlaying:false},()=>{})
        }else{
            this.setState({statusPlaying:true},()=>{
               var stvl = setInterval(()=>{
                    this.setState({statusPlaying:false},()=>{})
                    clearInterval(stvl)
                },3000)
            })
        }
    }
    renderItem = (css)=> {
        return (<div className={"card-ani " + ((this.state.statusPlaying)?css:"")}>
                    This example
                </div>)
    }
   
    render() {
        const { classes } = this.props;
        
        return (
            <div className={classes.container2 + " fullWidth"}>
                <Card>
                    <CardBody>
                        <GridContainer justify="center">
                            <GridItem xs={12} >
                                <h4>ทดสอบ Animation Dashboard</h4>
                            </GridItem>
                            <GridItem xs={12} >
                                
                            </GridItem>
                            <GridItem xs={12}>
                                <Button color="info" size="md" 
                                onClick={(e)=>this.onPlaying()}
                                >
                                    <SendIcon className={classes.icons} /> {(!this.state.statusPlaying)?"PLAY":"STOP"}
                                </Button>
                            </GridItem>
                        </GridContainer>
                    </CardBody>
                </Card>
                <Card>
                    <CardBody>
                        <GridContainer justify="center">
                            <GridItem xs={12} sm={12} md={11}>
                                
                                {this.renderItem("ani-move-1")}
                                {this.renderItem("ani-move-2")}
                                {this.renderItem("ani-move-3")}
                                {this.renderItem("ani-move-4")}
                                {this.renderItem("ani-move-5")}

                            </GridItem>
                        </GridContainer>
                    </CardBody>
                </Card>
            </div>
        );
    }
}

export default withStyles(styles)(ForTestPage);
